import { useEffect, useRef } from 'react'
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect'

/* istanbul ignore next */
/** keep typescript happy */
const noop = () => {}

export function useInterval(
  callback: () => void,
  delay: number | null | false,
  immediate?: boolean,
) {
  const savedCallback = useRef(noop)

  // Remember the latest callback.
  useIsomorphicLayoutEffect(() => {
    savedCallback.current = callback
  })

  // Execute callback if immediate is set.
  useEffect(() => {
    if (!immediate) return
    if (delay === null || delay === false) return
    savedCallback.current()
  }, [immediate])

  // Set up the interval.
  useEffect(() => {
    if (delay === null || delay === false) return undefined
    const tick = () => savedCallback.current()
    const id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}

// function useInterval(callback: () => void, delay: number | null) {
//   const savedCallback = useRef(callback)

//   // Remember the latest callback if it changes.
//   useIsomorphicLayoutEffect(() => {
//     savedCallback.current = callback
//   }, [callback])

//   // Set up the interval.
//   useEffect(() => {
//     // Don't schedule if no delay is specified.
//     // Note: 0 is a valid value for delay.
//     if (!delay && delay !== 0) {
//       return
//     }

//     const id = setInterval(() => savedCallback.current(), delay)

//     return () => clearInterval(id)
//   }, [delay])
// }

// export { useInterval }
